import React, { useMemo, useState } from 'react'
import { Box, FlexBox } from '../../Components/Boxes';
import { useResponsive } from '../../Components/Hooks';
import SettingsNav from './SettingsNav';
import { color, radius } from '../../Components/Theme';
import { CareplansSettings, CompliancesSettings, AdditionalFormsSettings, MedicineRefusalReasonsSettings, RiskassessmentsSettings, ServicesSettings, EventCheckListSettings, JobRolesSettings } from "./SettingsUI"
import MedicationSettings from './SettingsUI/MedicationSettings';
import usePermissionsController from '../../permissions';
import PolicyListSettings from './SettingsUI/PolicyListSettings';
import BusinessAccountSettings from './SettingsUI/BusinessAccountSettings';
import TimeOffApproversSettings from './SettingsUI/TimeOffApproversSettings';
import DefaultQualificationsSettings from './SettingsUI/DefaultQualificationsSettings';
import { CLIENT_TAB } from '../../constants/careRecords';

export default function Settings() {
    const isDesktop = useResponsive({ xs: false, sm: true });
    const {
        accessViewSettingsRiskassessments,
        accessViewSettingsTasks,
        accessViewSettingsCompliance,
        accessViewSettingsCareplans,
        accessViewSettingsMedication,
        accessViewSettingsRefusalReaosns,
        accessViewSettingsAdditionalForms,
        accessViewSettingsEventCheckLists,
        accessViewSettingsPolicy,
        accessViewSettingsJobroles,
        accessViewSettingsTimeOffApprovers,
        accessViewSettingsBusinessAccount,
        accessViewSettingsDefaultQualifications,
    } = usePermissionsController()
    const [tabIndex, setTabIndex] = useState(0)

    const tabOptions = useMemo(() => {
        const opts = []

        if (accessViewSettingsBusinessAccount) {
            opts.push({ name: "Business Account", icon: "Business" })
        }

        if (accessViewSettingsTasks) {
            opts.push({ name: "Tasks", icon: "FactCheck" })
        }
        if (accessViewSettingsCompliance) {
            opts.push({ name: "Compliances", icon: "Security" })
        }
        if (accessViewSettingsCareplans) {
            opts.push({ name: CLIENT_TAB.carePlan, icon: "Assignment" })
        }
        if (accessViewSettingsRiskassessments) {
            opts.push({ name: CLIENT_TAB.riskAssessment, icon: "GppMaybe" })
        }
        if (accessViewSettingsMedication) {
            opts.push({ name: CLIENT_TAB.medication, icon: "Medication" })
        }
        if (accessViewSettingsRefusalReaosns) {
            opts.push({ name: "Missed Medication Reasons", icon: "ReportProblem" })
        }
        if (accessViewSettingsAdditionalForms) {
            opts.push({ name: "Custom Forms", icon: "ListAlt" })
        }
        if (accessViewSettingsEventCheckLists) {
            opts.push({ name: "Shift Checklist", icon: "EventAvailable" })
        }
        if (accessViewSettingsPolicy) {
            opts.push({ name: "Policy List", icon: "Layers" })
        }
        if (accessViewSettingsJobroles) {
            opts.push({ name: "Job Roles", icon: "Work" })
        }
        if (accessViewSettingsTimeOffApprovers) {
            opts.push({ name: "Time Off Approvers", icon: "HowToReg" })
        }
        if (accessViewSettingsDefaultQualifications) {
            opts.push({ name: "Default Qualifications", icon: "School" })
        }

        return opts
    }, [
        accessViewSettingsRiskassessments,
        accessViewSettingsTasks,
        accessViewSettingsCompliance,
        accessViewSettingsCareplans,
        accessViewSettingsMedication,
        accessViewSettingsRefusalReaosns,
        accessViewSettingsAdditionalForms,
        accessViewSettingsEventCheckLists,
        accessViewSettingsPolicy,
        accessViewSettingsJobroles,
        accessViewSettingsBusinessAccount,
    ])

    return (
        <FlexBox
            $width="100%"
            $height="100%"
            $backgroundColor="surface"
            $borderRadius={`${radius("card")}px`}
            $flexDirection="column"
        >
            <div style={{ display: "flex", flexDirection: isDesktop ? "row" : "column", width: "100%", alignItems: "stretch" }}>
                <div style={{ flex: isDesktop ? "0 0 260px" : "0 0 auto", borderRight: isDesktop ? `1px solid ${color("border")}` : "none", minWidth: 0 }}>
                    <SettingsNav tabs={tabOptions} value={tabIndex} onChange={setTabIndex} />
                </div>

                <div style={{ flex: "1 1 auto", minWidth: 0 }}>
                    <Box $padding="5">
                        {tabOptions[tabIndex].name == "Business Account" && <BusinessAccountSettings />}
                        {tabOptions[tabIndex].name == "Missed Medication Reasons" && <MedicineRefusalReasonsSettings />}
                        {tabOptions[tabIndex].name == "Tasks" && <ServicesSettings />}
                        {tabOptions[tabIndex].name == "Compliances" && <CompliancesSettings />}
                        {tabOptions[tabIndex].name == CLIENT_TAB.carePlan && <CareplansSettings />}
                        {tabOptions[tabIndex].name == CLIENT_TAB.riskAssessment && <RiskassessmentsSettings />}
                        {tabOptions[tabIndex].name == CLIENT_TAB.medication && <MedicationSettings />}
                        {tabOptions[tabIndex].name == "Custom Forms" && <AdditionalFormsSettings />}
                        {tabOptions[tabIndex].name == "Shift Checklist" && <EventCheckListSettings />}
                        {tabOptions[tabIndex].name == "Policy List" && <PolicyListSettings/>}
                        {tabOptions[tabIndex].name == "Job Roles" && <JobRolesSettings />}
                        {tabOptions[tabIndex].name == "Time Off Approvers" && <TimeOffApproversSettings />}
                        {tabOptions[tabIndex].name == "Default Qualifications" && <DefaultQualificationsSettings />}
                    </Box>
                </div>
            </div>
        </FlexBox>
    )
}
